import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Settings from '../assets/icons/feather/Settings.svg?react';

export function SettingsIcon(props: SvgIconProps) {
  return <SvgIcon component={Settings} inheritViewBox {...props} />;
}
